/* eslint-disable no-param-reassign */
const wrapComponentRender = require('utils/framework/wrapComponentRender').wrapComponentRender;
const shouldPreventRender = require('utils/framework/wrapComponentRender').shouldPreventRender;
const React = require('react');


const wrapUFEFunctional = (comp, name = '') => {
    if (typeof name === 'string' && name.length && !comp.class) {
        comp.class = name;
    }

    comp.path = comp.componentName = comp.displayName = comp.class;
    comp.isFunctional = true;
    let compClass;

    if (!Sephora.isNodeRender) {
        // this is needed for the hidration process
        if (!(comp.isForcedRoot || comp.asyncRender)) {
            Sephora.Util.InflatorComps.Comps[comp.displayName] = {
                getReactClass: function () { // eslint-disable-line max-len, func-name-matching
                    return compClass;
                }
            };
            Sephora.Util.InflatorComps.Comps[comp.displayName].getReactClass.displayName = comp.displayName;
        }

        Sephora.Util.InflatorComps.Comps[comp.displayName].class = comp;
    }
    //copying backing up object props
    const objectProps = {};
    Object.assign(objectProps, comp);
    // wrapping up original functional component
    comp = wrapComponentRender(comp);
    //it is important for testing proposes to keep here the display name, otherwise a lot of component would be
    // identified as renderWrapper
    comp.displayName = objectProps.displayName;
    // after wrap the component with React.memo it is important to copy the rest of the component properties
    // like defaultProps or components assigned to a comp prop like Dropdown.Menu
    comp = React.memo(comp, (prevProps, nextProps) => {
        return shouldPreventRender(prevProps, nextProps, comp.shouldUpdatePropsOn);
    });
    Object.assign(comp, objectProps);
    comp.isComponent = true;

    return compClass = comp;
};

module.exports = wrapUFEFunctional;
